var map = {
	"./adult/de/wordchain-tutorial": 773,
	"./adult/nn/wordchain-tutorial": 774,
	"./adult/no/wordchain-tutorial": 775,
	"./youth/de/wordchain-tutorial": 776,
	"./youth/nn/wordchain-tutorial": 777,
	"./youth/no/wordchain-tutorial": 778,
	"./youth/se/wordchain-tutorial": 779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 772;